import { useLayoutEffect } from 'react';

export const useLockBodyScroll = (win: Window = window, doc: Document = document): void => {
  useLayoutEffect((): (() => void) => {
    const htmlTag = doc.getElementsByTagName('html')[0];
    const originalStyle = win.getComputedStyle(htmlTag).overflow;

    htmlTag.style.overflow = 'hidden';

    return () => {
      htmlTag.style.overflow = originalStyle;
    };
  });
};
